import React from 'react';
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { formatAmount, formatDateTime, summarizeAllocations } from './utils';

const AssignedPaymentTransactionsCard = ({
    transactions,
    loading,
    error,
    onEdit,
}) => (
    <Card variant="outlined">
        <CardHeader title="Zugeordnete PayPal-Vorgänge" />
        <CardContent>
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    {error}
                </Alert>
            )}
            {loading ? (
                <Typography color="text.secondary">Lade PayPal-Vorgänge...</Typography>
            ) : transactions.length === 0 ? (
                <Alert severity="info">Keine zugeordneten PayPal-Vorgänge gefunden.</Alert>
            ) : (
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Datum</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Typ</TableCell>
                                <TableCell align="right">Netto</TableCell>
                                <TableCell align="right">Gebuehr</TableCell>
                                <TableCell>Waehrung</TableCell>
                                <TableCell>Beschreibung</TableCell>
                                <TableCell>Zuordnungen</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {transactions.map((tx) => {
                                const netAmount = Number(tx.netAmount ?? 0);
                                const feeAmount = Number(tx.feeAmount ?? 0);
                                return (
                                    <TableRow key={tx.id}>
                                        <TableCell>{formatDateTime(tx.transactionDateTime)}</TableCell>
                                        <TableCell>{tx.name || '-'}</TableCell>
                                        <TableCell>{tx.type || '-'}</TableCell>
                                        <TableCell align="right">
                                            {formatAmount(netAmount, tx.currency)}
                                        </TableCell>
                                        <TableCell align="right">
                                            {formatAmount(feeAmount, tx.currency)}
                                        </TableCell>
                                        <TableCell>{tx.currency || '-'}</TableCell>
                                        <TableCell>{tx.description || '-'}</TableCell>
                                        <TableCell>{summarizeAllocations(tx.allocations, tx.currency)}</TableCell>
                                        <TableCell>
                                            <Button size="small" onClick={() => onEdit(tx)}>
                                                Ändern
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </Box>
            )}
        </CardContent>
    </Card>
);

export default AssignedPaymentTransactionsCard;
